// We will add all the endpoints here

export const ENDPOINTS = {
  //Roles
  ROLES: "api/roles/me",
  //Auth
  LOGIN: "api/auth/login",
  SIGNUP: "api/register",
  GET_USER: "api/user/me",
  //Upload
  UPLOAD_FILE: (jobName: string, dataSource: string) =>
    `api/upload-sessions/upload?jobName=${jobName}&dataSource=${dataSource}`,
  UPLOAD_STYLE_IDS: `api/upload-sessions/manual`,
  UPLOAD_STYLE_IDS_BY_URL: `api/upload-sessions/scrape`,
  GET_UPLOADED_DATA: (uploadSessionId: string) =>
    `api/uploaded-styles/upload-session/${uploadSessionId}?page=0&size=3000`,
  SCHEDULE_JOB_STYLES: `api/job-style-assignments/schedule`,
  //Style Details
  GET_STYLE_DETAILS: "api/style-details",
  GET_DATA_SOURCES: "api/upload-sessions/data-sources",
  GET_SCHEDULED_JOBS: (
    page: number = 0,
    size: number = 50,
    searchParam?: string
  ) =>
    `api/scheduled-jobs?page=${page}&size=${size}${
      searchParam
        ? `&searchParam=${encodeURIComponent(searchParam.trim())}`
        : ""
    }`,
  GET_SCHEDULED_JOB_STYLE_DETAILS: (
    jobId: string,
    page: number = 0,
    size: number = 50,
    styleId?: string
  ) =>
    `api/style-details/job/${jobId}?&page=${page}&size=${size}${
      styleId ? `&styleId=${encodeURIComponent(styleId.trim())}` : ""
    }`,
  GET_SCHEDULED_JOB_STYLE_DETAILS_AGGREGATED: (
    jobId: string,
    page: number = 0,
    size: number = 50,
    styleId?: string
  ) =>
    `api/style-details/job/${jobId}?aggregated=true&page=${page}&size=${size}${
      styleId ? `&styleId=${encodeURIComponent(styleId.trim())}` : ""
    }`,
  JOB_STYLES_EXCEL_DOWNLOAD: (jobId: string) =>
    `api/style-details/job/excel-download/${jobId}`,
  DELETE_JOB: (jobId: number) => `api/scheduled-jobs/${jobId}`,
  //Export (previously Analytics)
  GET_ANALYTICS_JOB_FILTER: (jobId: string) =>
    `api/style-detail-summaries/filters/${jobId}`,
  GET_ANALYTICS_TABLE_DATA_BY_JOB_ID: (jobId: string) =>
    `api/style-detail-summaries/summary/${jobId}`,
  ANALYTICS_STYLES_EXCEL_DOWNLOAD: (jobId: string) =>
    `api/sku-daily-differences/excel-download/${jobId}`,
  ANALYTICS_JOB_FILTER_EXCEL_DOWNLOAD: (jobId: string) =>
    `api/style-detail-summaries/style-excel-download/${jobId}`,
  //Insights
  INSIGHTS_JOB_FILTER_EXCEL_DOWNLOAD: (jobId: string) =>
    `api/style-detail-summaries/insights-excel-download/${jobId}`,
  GET_INSIGHTS_FOR_JOBS: (jobId: string) =>
    `api/job-insight-summaries/list-insights/${jobId}`,
  GET_INSIGHTS_FOR_JOB_BY_DATE: (
    jobId: string,
    date: string,
    page: number = 0,
    size: number = 50
  ) =>
    `api/job-insight-summaries/insights/${jobId}?insightId=${date}&page=${page}&size=${size}`,
  GET_INSIGHTS_FOR_JOB_BY_POPULAR_STYLE: (jobId: string, date: string) =>
    `api/job-insight-summaries/insights/popular/${jobId}?insightId=${date}`,
  GET_INSIGHTS_FOR_JOB_BY_TRENDING_STYLE: (
    jobId: string,
    date: string,
    trendDate: string
  ) =>
    `api/job-insight-summaries/insights/trending/${jobId}?insightId=${date}&trendStartDate=${trendDate}`,
  DOWNLOAD_INSIGHTS_FOR_DATE: (jobId: string, date: string) =>
    `api/job-insight-summaries/csv-download/${jobId}?insightId=${date}`,
  GENERATE_INSIGHTS: (jobId: string, startDate: string, endDate: string) =>
    `api/job-insight-summaries/${jobId}?startDate=${startDate}&endDate=${endDate}`,
  GET_INSIGHTS_AVERAGE_RATINGS: (jobId: string, date: string) =>
    `api/job-insight-summaries/insights/average-rating/${jobId}?insightId=${date}`,
  GET_INSIGHTS_INVENTORY_DISTRIBUTION: (jobId: string, date: string) =>
    `api/job-insight-summaries/insights/inventory-distribution/${jobId}?insightId=${date}`,
  GET_INSIGHTS_REVENUE_DISTRIBUTION: (jobId: string, date: string) =>
    `api/job-insight-summaries/insights/revenue-distribution/${jobId}?insightId=${date}`,
  GET_INSIGHTS_AVERAGE_VALUES: (jobId: string, date: string) =>
    `api/job-insight-summaries/insights/average-values/${jobId}?insightId=${date}`,
  //AI Chat
  CHAT: "chat",
  //Tenants
  GET_TENANTS: "api/tenants",
  REASSIGN_TENANTS: (jobId: string) =>
    `api/scheduled-jobs/${jobId}/reassign-tenants`,
};
